import {matchPath} from 'react-router';
import {PageTypePathMap} from './route.paths';
import {PageTypes} from './types';

export const getParams = <Params extends Record<string, string>>({
  currentPageType,
  pageTypePathsMap,
  pathname,
}: {
  pathname: string;
  currentPageType: PageTypes | undefined;
  pageTypePathsMap: PageTypePathMap;
}) => {
  if (!currentPageType) {
    return {} as Params;
  }

  if (currentPageType === '404') {
    return {} as Params;
  }

  const patterns = pageTypePathsMap[currentPageType];
  for (const pattern of patterns) {
    const match = matchPath(pathname, {
      path: pattern,
      strict: false,
    });
    if (!match) {
      continue;
    }
    return (match.params ?? {}) as Params;
  }
  return {} as Params;
};
